import { apiClient, APIResponse, extractApiError, buildQuery } from './api';

export const potsAPI = {
  async list(params) {
    try {
      const { data } = await apiClient.get(`/pots/${buildQuery(params)}`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar os cofres.'),
      );
    }
  },

  async retrieve(id) {
    try {
      const { data } = await apiClient.get(`/pots/${id}/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o cofre.'),
      );
    }
  },

  async monthlyCommitment() {
    try {
      const { data } = await apiClient.get('/pots/monthly-commitment/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível calcular o compromisso mensal.'),
      );
    }
  },

  async createFromOccasional(occasionalId) {
    try {
      const { data } = await apiClient.post(
        `/pots/from-occasional/${occasionalId}/`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar o cofre.'),
      );
    }
  },

  // CHANGE v2 §24: histórico do cofre vem de Expense (savings_pot=id).
  async history(id) {
    try {
      const { data } = await apiClient.get(`/pots/${id}/history/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o histórico.'),
      );
    }
  },

  // CHANGE v2 §24: encerrar cofre com REVERT_ALL ou KEEP_HISTORY.
  async close(id, action) {
    try {
      const { data } = await apiClient.post(`/pots/${id}/close/`, { action });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível fechar o cofre.'),
      );
    }
  },

  // CHANGE v2 §14.6: confirma ou salta a contribuição mensal a partir da selfie.
  async confirmMonthlyContribution(id, { action, year, month }) {
    try {
      const { data } = await apiClient.post(
        `/pots/${id}/confirm-monthly-contribution/`,
        { action, year, month },
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível confirmar a contribuição.'),
      );
    }
  },

  async transfer({ fromPotId, toPotId, amount }) {
    try {
      const { data } = await apiClient.post('/pots/transfer/', {
        from_pot: fromPotId,
        to_pot: toPotId,
        amount,
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível mover entre cofres.'),
      );
    }
  },
};
